import React from "react";
import { useGetThemeOptionsQuery } from "../../../services/themeApi";

const HeaderMenuAboutUs = () => {
    // Pobieranie opcji motywu za pomocą RTK Query
    const { data: themeOptions, isLoading, isError } = useGetThemeOptionsQuery();

    if (isLoading) {
        return null; // Możesz tutaj zwrócić loader, jeśli to konieczne
    }

    if (isError || !themeOptions) {
        console.error("Error fetching theme options or data unavailable");
        return null;
    }

    const aboutUsItems = themeOptions.menu_short_aboutus;

    if (!aboutUsItems?.length) {
        return null;
    }

    return (
        <div className="submenu-aboutus">
            {aboutUsItems.map((item, index) => (
                <div className="submenu-aboutus--item" key={index}>
                    <div className="submenu-aboutus--item__left">
                        <img
                            src={item.short_aboutus_img.url}
                            alt={item.short_aboutus_img.alt || "Logo"}
                            width={item.short_aboutus_img.width}
                            height={item.short_aboutus_img.height}
                            title={item.short_aboutus_img.title}
                        />
                    </div>
                    <div className="submenu-aboutus--item__right">
                        <span className="submenu-aboutus--item__right--name">
                            {item.short_aboutus_name}
                        </span>
                        <span className="submenu-aboutus--item__right--position">
                            {item.short_aboutus_position}
                        </span>
                        <span className="submenu-aboutus--item__right--tel tel-icon">
                            {item.short_aboutus_tel}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default HeaderMenuAboutUs;
